import styled from 'styled-components/macro';

// import theme helpers
import { getColor } from '../../../util/theme';

const FormSelectWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  position: relative;

  span {
    color: ${getColor('white')};
    font-size: 1.4rem;
    &.tooltip {
      display: flex;
      align-items: center;
      justify-content: center;

      height: 2rem;
      width: 2rem;

      border: 1px solid ${getColor('white')};
      border-radius: 50%;

      &:hover,
      &:focus {
        ~ span {
          display: block;
        }
      }
    }

    &.tooltip-content {
      display: none;

      position: absolute;
      left: 100px;
      bottom: 25px;

      background-color: ${getColor('primaryBlue')};

      border: 1px solid ${getColor('accentGreen')};

      padding: 15px;

      &:hover {
        display: block;
      }

      a {
        color: ${getColor('accentGreen')};
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`;

export default FormSelectWrapper;
